import { colors, spacing } from "@procore/core-react";

export const HEADER_BORDER = `1px solid ${colors.gray90}`;

/** Inset between the viewer container edge and a Window's draggable bounds. */
export const VIEWER_INSET = spacing.sm;

/** Horizontal and vertical padding used by SlottedWindow's header rows. Match this in body content to align with the header. */
export const SLOTTED_WINDOW_HEADER_PADDING = spacing.lg;
